import React from "react";
import { useParams } from "react-router-dom-v5-compat";
import Viewer from "../Viewer";

const ShareModel = () => {
	const { urn, fileId } = useParams();
	const parsedFileId = fileId ? parseInt(fileId, 10) : null;

	return (
		<div className="share-view">
			<Viewer shareModelUrn={urn} fileId={parsedFileId} />
		</div>
	);
};

export default ShareModel;
